module.exports = __webpack_public_path__ + "img/suggestion_lembaga_instruction.dba1b81f.svg";